export interface SkillGroup {
  id: "frontend" | "ai" | "backend" | "data" | "devops";
  label: string;
  items: string[];
}

/** Five bento cells. The sixth cell is the marquee of everything else. */
export const skillGroups: SkillGroup[] = [
  { id: "frontend", label: "Front end", items: ["React", "React Native", "Next.js", "TypeScript", "JavaScript", "Redux", "Tailwind"] },
  { id: "ai", label: "AI & LLM", items: ["OpenAI API", "Prompt engineering", "Embeddings", "Token optimisation"] },
  { id: "backend", label: "Back end", items: ["Node.js", "NestJS", "Express", "Laravel", "PHP", "Microservices"] },
  { id: "data", label: "Data", items: ["MongoDB", "PostgreSQL", "MySQL", "Firestore", "Redis"] },
  { id: "devops", label: "DevOps & cloud", items: ["CI/CD", "Docker", "AWS EC2", "S3", "Amplify", "CodePipeline", "CodeDeploy"] },
];

export const alsoUse = ["RBAC", "JWT", "Socket.io", "RabbitMQ", "MQTT", "Jest", "Vite", "Figma", "UI/UX design"];
